import * as React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { MasonryPhotoAlbum } from "react-photo-album";
import "react-photo-album/masonry.css";
import { useTranslation } from "react-i18next";
import p1 from "../assets/gallery/1.jpg";
import p2 from "../assets/gallery/2.jpg";
import p3 from "../assets/gallery/3.jpg";
import p4 from "../assets/gallery/4.jpg";
import p5 from "../assets/gallery/5.jpg";
import p6 from "../assets/gallery/6.jpg";
import p7 from "../assets/gallery/7.JPG";
import p8 from "../assets/gallery/8.jpg";
import p9 from "../assets/gallery/9.jpg";
import p10 from "../assets/gallery/10.jpg";
import g1 from "../assets/gallery/gun-1.jpg";
import g2 from "../assets/gallery/gun-2.jpg";
import g3 from "../assets/gallery/gun-3.jpg";
import g4 from "../assets/gallery/gun-4.jpg";
import g5 from "../assets/gallery/gun-5.jpg";
import g6 from "../assets/gallery/gun-6.jpg";

const basePhotos = [
  {
    src: p1,
    width: 1200,
    height: 825,
  },
  {
    src: p2,
    width: 1200,
    height: 800,
  },
  {
    src: p3,
    width: 1200,
    height: 800,
  },
  {
    src: p4,
    width: 1500,
    height: 1000,
  },
  {
    src: p5,
    width: 1800,
    height: 1275,
  },
  {
    src: p6,
    width: 1062,
    height: 708,
  },
  {
    src: p7,
    width: 1500,
    height: 1000,
  },
  {
    src: p8,
    width: 1500,
    height: 1000,
  },
  {
    src: p9,
    width: 600,
    height: 400,
  },
  {
    src: p10,
    width: 1500,
    height: 1000,
  },
  {
    src: g1,
    width: 1500,
    height: 1000,
  },
  {
    src: g2,
    width: 1500,
    height: 1000,
  },
  {
    src: g3,
    width: 1000,
    height: 1500,
  },
  {
    src: g4,
    width: 1000,
    height: 1500,
  },
  {
    src: g5,
    width: 1280,
    height: 853,
  },
  {
    src: g6,
    width: 1500,
    height: 1000,
  },
];

function shuffleArray<T>(array: T[]): T[] {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

export default function Gallery() {
  const shuffledPhotos = React.useMemo(() => shuffleArray(basePhotos), []);
  const { t } = useTranslation();

  return (
    <Box
      id="gallery"
      sx={{
        pt: { xs: 4, md: 6 },
        px: { xs: 2, md: 0 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: { xs: "100%", lg: "60%" },
          px: { xs: 3, md: 6 },
          py: { xs: 2, md: 4 },
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h4" component="h2" gutterBottom>
          {t("home.galleryTitle")}
        </Typography>
        <Typography
          variant="overline"
          color="text.secondary"
          sx={{ letterSpacing: 1 }}
        >
          {t("home.galleryCaption")}
        </Typography>
        <Box sx={{ mt: 4 }} />
        <MasonryPhotoAlbum photos={shuffledPhotos} />
      </Paper>
    </Box>
  );
}
